import { Component, OnInit, ViewChild } from '@angular/core';
import { ToastComponent } from "../../../../../shared/components/toast/toast.component";
import { AdminTopbarComponent } from "../../../components/admin-topbar/admin-topbar.component";
import { AdminNavigationComponent } from "../../../components/admin-navigation/admin-navigation.component";
import { TranslocoPipe } from '@jsverse/transloco';
import { CustomButtonComponent } from "../../../../../shared/components/custom-button/custom-button.component";
import { IndicatorType, IndicatorVariableGet } from '../../../../../core/interfaces/sales-engine-interfaces';
import { ApiErrorService } from '../../../../../core/api/api-error.service';
import { SalesEngineService } from '../../../../../core/api/sales-engine.service';
import { HttpErrorResponse } from '@angular/common/http';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-admin-variables-page',
  standalone: true,
  imports: [ToastComponent, AdminTopbarComponent, AdminNavigationComponent, TranslocoPipe, CommonModule],
  templateUrl: './admin-variables-page.component.html',
  styleUrl: './admin-variables-page.component.css'
})
export class AdminVariablesPageComponent implements OnInit {
  constructor(private apiError: ApiErrorService, private salesEngineService: SalesEngineService) { }

  // Toast
  @ViewChild(ToastComponent) toast!: ToastComponent;

  // Variables
  systemVariables: IndicatorVariableGet[] = [];
  loadedsystemVariables: IndicatorVariableGet[] = [];

  ngOnInit(): void {
    this.reloadSystemVariables();
  }

  loadSystemVariables() {
    this.salesEngineService.getIndicatorVariables().subscribe({
      next: (response) => {
        if (response) {
          this.loadedsystemVariables = [...response];

          this.systemVariables = [];
          this.systemVariables = this.loadedsystemVariables;
        }
      },
      error: async (error) => {
        var crid = 'UNKNOWN-CRID';

        if (error instanceof HttpErrorResponse) {
          crid = error.headers?.get('x-correlation-id') || 'UNKNOWN-CRID';
        }
        this.toast.showToast(await this.apiError.getErrorHeader(), await this.apiError.getErrorMessage(crid), 'error', 8000, false);
      },
      complete: () => {
      }
    });
  }

  reloadSystemVariables = () => {
    this.loadedsystemVariables = [];
    this.systemVariables = [];
    this.loadSystemVariables();
  }

  getDataTypeBackgroundColor(type: IndicatorType): string {
    if (type == IndicatorType.DATE) {
      return 'bg-error-100';
    }
    else if (type == IndicatorType.NUMBER) {
      return 'bg-blue-100';
    }
    else if (type == IndicatorType.STRING) {
      return 'bg-success-100';
    }
    return 'bg-primary-300';
  }
}
